import React from "react";
import { useEffect, useState } from "react";
import { legendItemStyle, legendStyle } from "./style";
import { getRainFallSevenDayCreationTime } from "../../lib/getRainfallData";

const Rainfall7daysLegend = () => {
  const [forecastCreationTime, setForecastCreationTime] = useState(null);
  useEffect(() => {
    const fetchCreationTime = async () => {
      try {
        const time = await getRainFallSevenDayCreationTime();

        const year = time.substring(0, 4);
        const month = time.substring(4, 6);
        const day = time.substring(6, 8);
        const formattedDate = `${day}/${month}/${year}`;

        setForecastCreationTime(formattedDate);
      } catch (error) {
        console.error("Error fetching creation time:", error);
      }
    };

    fetchCreationTime();
  }, []);

  return (
    <div style={legendStyle}>
      <div>
        <b>7-d Rainfall Accum. (GPM)</b>
      </div>
      <div
        style={{
          display: "flex",
        }}
      >
        <div
          style={{
            flex: "50%",
          }}
        >
          <div>
            <span style={legendItemStyle("#8F0000")}></span>
            600mm
          </div>
          <div>
            <span style={legendItemStyle("#C80001")}></span>
            350mm
          </div>
          <div>
            <span style={legendItemStyle("#FE0100")}></span>
            200mm
          </div>
          <div>
            <span style={legendItemStyle("#FF9400")}></span>
            120mm
          </div>
          <div>
            <span style={legendItemStyle("#FBC500")}></span>
            70mm
          </div>
          <div>
            <span style={legendItemStyle("#F9F602")}></span>
            40mm
          </div>
        </div>
        <div
          style={{
            flex: "50%",
          }}
        >
          <div>
            <span style={legendItemStyle("#B5E700")}></span>
            20mm
          </div>
          <div>
            <span style={legendItemStyle("#57D006")}></span>
            10mm
          </div>
          <div>
            <span style={legendItemStyle("#02B331")}></span>
            5mm
          </div>
          <div>
            <span style={legendItemStyle("#028C4E")}></span>
            3mm
          </div>
          <div>
            <span style={legendItemStyle("#028414")}></span>
            2mm
          </div>
          <div>
            <span style={legendItemStyle("#C0C0C0")}></span>
            1mm
          </div>
        </div>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {forecastCreationTime && <p>Creation Date: {`${forecastCreationTime}`}</p>}
          {forecastCreationTime && <p>Creation Time: 23:00 CET</p>}
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, GPM IMERG Late Precipitation L3 7-day Accumulation V06, NASA GSFC, Precipitation
          Processing System, PMM Publisher API: https://pmmpublisher.pps.eosdis.nasa.gov, processed by
          CyStellar
        </span>
      </div>
    </div>
  );
};

export default Rainfall7daysLegend;
